import get from 'lodash/get';

const roles = {
    ROLE_PRESCRIBER: 'Prescripteur',
    ROLE_OPERATOR: 'Opérateur',
    ROLE_MANAGER: 'Manager',
    ROLE_ADMIN: 'Administrateur',
};

function formatRoles(pRoles: string[]): string {
    const array: string[] = [];
    pRoles.map(item => {
        const res = get(roles, item, item);
        array.push(res);
    });
    return array.join(', ');
}

export { roles, formatRoles };
